require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/node_modules/babel-preset-stage-0/lib/index.js\",\"/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./index.js") })
        }
      }, "component---src-pages-index-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-index-js!./src/pages/index.js
// module id = 481
// module chunks = 231608221292675